module.exports = __webpack_public_path__ + "img/fasie_logo.25aeb50a.png";